import React from "react"
import Cookies from "js-cookie"
import PropTypes from "prop-types"
import { StudentDashboard, StudentResourceMenu } from "./components"
import "../../assets/css/components/StudentHomepage/StudentHomepage.css"
import { useViewPortObserver } from "../../customeHooks"
import _ from "lodash"
import { runQuery } from "../../fetchUtils"
import { getCurrentRole, CHILD, STUDENT, getURLParams } from "../../util"

const StudentHomepage = ({ currentUser, handleHideIntercom }) => {
  const userRole = getCurrentRole(currentUser)
  const studentHome = React.useRef()
  const size = useViewPortObserver(studentHome)
  const defaultPublicWorld = [
    {
      sectionName: "Public World",
      sectionId: "0",
      instructor: [],
      assignments: []
    }
  ]

  const [studentClassData, setStudentClassData] = React.useState([])
  const [updatedAssignment, setUpdatedAssignment] = React.useState(false)
  /* Incoming class assignments will be filtered and sorted by date, since there both normal quest
		and sandbox intro quests will be treated as normal quests, in no case should the quest field be null. 
		handleStudentDataConversion() will simply convert the incoming class assignment to the proper json 
		format for display.
	*/
  const handleStudentDataConversion = (classAssignment, sortBy, sortOrder) => {
    return _.orderBy(classAssignment, sortBy, sortOrder).map(classAssignment => {
      return {
        sectionName: classAssignment.section.name,
        sectionId: classAssignment.section.id,
        instructor: classAssignment.section.instructorProfiles.map(
          instructor => instructor.lastName
        ),
        assignments: _.sortBy(classAssignment.assignments, assignment => {
          return new Date(assignment.assignDate)
        }).map(assignment => assignment.quest.name)
      }
    })
  }

  //This fetch should also return sandbox data at a later point when sandbox overhaul
  //is being worked on.
  const handleFetchStudentClassData = () => {
    const fetchStudentDataQuery = `
			query LoadStudentData{
				students{
					id
					joinDate: createdAt
					section{
						id
						name
						instructorProfiles{
							lastName
						}
					}
					assignments: currentAssignments {
						quest{
							name
						}
						assignDate: toBeAssignedAt
					}
				}
			}
		`

    const vars = {}

    const fetchStudentClassData = {
      onComplete: json => {
        const error = json.data.error
        if (!_.isEmpty(error)) {
          console.error(error)
        } else {
          if (!_.isEmpty(json.data.students)) {
            const studentClassAssignment = handleStudentDataConversion(
              json.data.students,
              "joinDate",
              "asc"
            )
            setStudentClassData(
              userRole === STUDENT
                ? studentClassAssignment
                : [...defaultPublicWorld, ...studentClassAssignment]
            )
          } else {
            setStudentClassData(userRole === CHILD ? defaultPublicWorld : [])
          }
        }
      },
      onFailure: error => {
        console.log(error)
      }
    }

    runQuery(fetchStudentDataQuery, vars, fetchStudentClassData)
  }

  React.useEffect(() => {
    handleFetchStudentClassData()
  }, [updatedAssignment])

  const handleCreateThirdPartyAssignment = userUuid => {
    const createAssignmentQuery = `
              mutation AssignThirdPartyContent($userUuid: ID!, $classCode: String, $questId: ID, $storylineId: ID){
                assignThirdPartyContent(userUuid: $userUuid, classCode:$classCode, questId: $questId, storylineId: $storylineId){
                  message
                  errors
                }
              }
            `
    const createAssignmentCallBack = {
      onComplete: json => {
        const data = json.data.assignThirdPartyContent

        const cookieDetail = { path: "/", domain: ".tytoonline.com" }
        _.forEach(["classCode", "questId", "storylineId"], cookieName => {
          Cookies.remove(cookieName, cookieDetail)
        })

        if (!_.isEmpty(data?.errors)) {
          console.log(data.errors)
        } else {
          console.log(data?.message)
          setUpdatedAssignment(true)
        }
      },
      onFailure: error => {
        console.error(error)
      }
    }

    const { classCode, questId, storylineId } = Cookies.get()

    if (questId || storylineId) {
      console.log("calling make third party assignment...")
      let vars = {
        userUuid,
        ...(classCode && { classCode }),
        ...(questId && { questId }),
        ...(storylineId && { storylineId })
      }
      runQuery(createAssignmentQuery, vars, createAssignmentCallBack)
    } else {
      console.error("incoming request missing parameter questId or storylineId")
    }
  }
  React.useEffect(() => {
    if (currentUser?.["third-party-provider"]) {
      handleCreateThirdPartyAssignment(currentUser.uuid)
    }
  }, [])

  return (
    <div className='studentHomepage' ref={studentHome}>
      <StudentDashboard
        currentUser={currentUser}
        componentSize={size}
        classAssignmentData={studentClassData}
      />
      <StudentResourceMenu handleHideIntercom={handleHideIntercom} />
    </div>
  )
}

StudentHomepage.propTypes = {
  currentUser: PropTypes.object.isRequired
}

export default StudentHomepage
